/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import { Switch } from "@mui/material";
import Pagination from "../../../../Helper/Pagination";

export default function Coupon() {
  const [couponList, setcouponList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);

  const [cuponevent, setcuponevent] = useState("");
  const [cuponcode, setcuponcode] = useState("");
  const [type, settype] = useState("");
  const [discount, setdiscount] = useState("");
  const [status, setstatus] = useState("");
  const [state, setstate] = useState("");
  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getCouponList();
  }, [search_key, currentPage]);

  useEffect(() => {
    setcuponevent(selectedData?.cuponevent);
    setcuponcode(selectedData?.cuponcode);
    setdiscount(selectedData?.discount);
    settype(selectedData?.type);
    setstatus(selectedData?.status);
  }, [selectedData]);

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  const getCouponList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_COUPON_LIST, param).then((res) => {
      if (res?.data?.status === true) {
        setcouponList(res?.data?.data?.item);
        SetTotalPageCount(res?.data?.data?.totalPages);
        SetTotalCount(res?.data?.data?.totalItems);
        setCount(res?.data?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_COUPON_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getCouponList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };
  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_COUPON, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getCouponList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  function resetFunc() {
    setcuponevent("");
    setcuponcode("");
    setdiscount("");
    settype("");
    setError(false);
    setsubmitLoader(false);
  }

  function AddCoupon() {
    if (!cuponcode || !cuponevent || !type || !discount) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const data = {
      cuponcode,
      cuponevent,
      type,
      status,
      discount,
      id: selectedData?.cupon_id,
    };
    const route = state === "Add" ? API_URL.ADD_COUPON : API_URL.UPDATE_COUPON;
    PostService(route, data).then((res) => {
      setsubmitLoader(false);
      if (res?.data?.status) {
        document.getElementById("closeEditModal").click();
        showSuccessAlert(res?.data?.message, getCouponList);
      } else {
        showErrorAlert(res.data?.message);
      }
    });
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Coupons List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Coupons List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div className="card-body ">
          <div className="align-items-center d-flex justify-content-between row">
            <div className="col-md-4 p-0">
              <div className="offset-md-1">
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  data-toggle="modal"
                  data-target="#AddModal"
                  onClick={() => {
                    setstate("Add");
                    resetFunc();
                  }}
                >
                  Add Coupon
                </button>
              </div>
            </div>
            <div className="col-md-4 p-0">
              <nav className="navbar">
                <input
                  type="text"
                  name="firstnamesearch"
                  placeholder="Search by Keyword"
                  className="form-control"
                  autoComplete="off"
                  onChange={(e) => {
                    setTimeout(() => {
                      setsearch_key(e.target.value);
                      setCurrentPage(0);
                    }, 400);
                  }}
                />
              </nav>
            </div>
          </div>
          <div class="table-responsive mt-3">
            {!loading && (
              <table class="table table-hover table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Event Name</th>
                    <th>Coupon Code</th>
                    <th>Discount</th>
                    <th>Type</th>
                    <th>status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {couponList?.map((item, i) => (
                    <tr>
                      <td>{i + 1}</td>
                      <td>{item?.cuponevent}</td>
                      <td>{item?.cuponcode}</td>
                      <td>{item?.discount}</td>
                      <td>{item?.type}</td>
                      <td>
                        <label
                          className={
                            item?.status === "active"
                              ? "badge badge-success"
                              : "badge badge-danger"
                          }
                        >
                          {" "}
                          {item?.status}
                        </label>
                      </td>
                      <td>
                        <span className="toggle-switch">
                          <Switch
                            checked={item?.status === "active"}
                            onChange={() => {
                              changeStatus(item?.cupon_id, item.status);
                            }}
                            size="small"
                            color="primary" // You can customize the color
                            inputProps={{
                              "aria-label": "toggle switch",
                            }}
                          />
                        </span>
                        <span
                          title="Edit"
                          style={{ cursor: "pointer" }}
                          className="mx-2"
                          data-toggle="modal"
                          data-target="#AddModal"
                          onClick={() => {
                            setSelectedData(item);
                            setstate("Edit");
                          }}
                        >
                          <i className="text-dark fas fa-pen"></i>
                        </span>
                        <span
                          title="Delete"
                          style={{ cursor: "pointer" }}
                          className="mx-2"
                          data-toggle="modal"
                          data-target="#DeleteModal"
                          onClick={() => {
                            Delete(item?.cupon_id, "Coupon");
                          }}
                        >
                          <i className="text-danger fas fa-trash"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {couponList && couponList?.length === 0 && (
                  <tr>
                    <td colSpan="9" className="text-center">
                      <h6 className="p-3"> No Data Found </h6>
                    </td>
                  </tr>
                )}
              </table>
            )}
            {loading ? (
              <div className="LoaderSpinner">
                  <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
            <div className="mt-4">
              <Pagination
                counting={S_No_Count}
                totaldata={TotalCount}
                pagecount={TotalPageCount}
                onChangePage={handlePageClick}
                activePage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="AddModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Coupon
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="form-group">
                  <label>Coupon Event</label>
                  <input
                    type="text"
                    name="ShippingCharge"
                    className="form-control"
                    placeholder="Coupon Name"
                    value={cuponevent}
                    onChange={(e) => {
                      setcuponevent(e?.target?.value);
                    }}
                  />
                  {error && !cuponevent && (
                    <div className="error mt-1">Coupon event is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Coupon Code</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Coupon Code"
                    value={cuponcode}
                    onChange={(e) => {
                      setcuponcode(e?.target?.value);
                    }}
                  />
                  {error && !cuponcode && (
                    <div className="error mt-1">Coupon code is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Discount</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => {
                      setdiscount(e?.target?.value);
                    }}
                  />
                  {error && !discount && (
                    <div className="error mt-1">Discount is required</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Type</label>
                  <select
                    className="form-control"
                    value={type}
                    onChange={(e) => settype(e?.target?.value)}
                  >
                    <option value="" default hidden>
                      Select
                    </option>
                    <option value="percent">Percent</option>
                    <option value="fixed">Fixed</option>
                  </select>
                  {error && !type && (
                    <div className="error mt-1">Type is required</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary py-2"
                  onClick={() => {
                    AddCoupon();
                  }}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i> // Replace with the appropriate Font Awesome spinner class
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
